module.exports = __webpack_public_path__ + "img/user-img.cd0a9821.png";